import './button.scss'
import Loader from './Loader'

/**
 * @param {Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> & {
 *   type?: 'primary' | 'secondary' | 'red' | 'green',
 *   size?: 'large' | 'medium' | 'small',
 *   badge?: string,
 *   label?: string,
 *   loading?: boolean,
 *   children?: React.ReactNode
 * }} props
 */
export default function Button({ children, type = 'primary', label, size = 'medium', loading = false, disabled = false, badge = '', className = '', ...props }) {
  return (
    <Loader loading={loading}>
      <span className='button-wrapper'>
        <button type='button' disabled={disabled} className={`invision-button ${type ? 'btn-type-' + type : ''} ${size ? 'btn-size-' + size : ''} ${className}`} {...props}>
          {label || children}
        </button>
        {badge ? <span className={`badge ${type}`}>{badge}</span> : ''}
      </span>
    </Loader>
  )
}

/**
 * A variation of the button component, but using an anchor for links.
 *
 * @param {Object} attributes
 * @param {string} attributes.type 'primary'|'secondary'|'red'|'green'
 * @param {string} attributes.size 'large'|'medium'|'small'
 * @param {boolean} attributes.loading Loading state shown when true.
 * @param {string} attributes.label - Text shown in the button, takes precidence over `children`.
 * @param {import('react').ReactNode} attributes.children - Elements shown inside the button.
 */
function Anchor({ children, type = 'primary', label, size = 'medium', loading = false, ...props }) {
  return (
    <Loader loading={loading}>
      <span className='button-wrapper'>
        <a type='button' className={`invision-button ${type ? 'btn-type-' + type : ''} ${size ? 'btn-size-' + size : ''}`} {...props}>
          {label || children}
        </a>
      </span>
    </Loader>
  )
}

export { Button, Anchor }
